import React from 'react';
import './TransactionDetailModal.css';

const TransactionDetailModal = ({ isOpen, onClose, transaction }) => {
  if (!isOpen || !transaction) return null;

  const formatCurrency = (amount) => {
    return `PKR ${amount.toLocaleString()}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-PK', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusColor = (status) => {
    const colors = {
      completed: '#28a745',
      pending: '#ffc107',
      processing: '#17a2b8',
      failed: '#dc3545',
      cancelled: '#6c757d'
    };
    return colors[status] || '#6c757d';
  };

  const getTypeIcon = (type) => {
    if (type === 'deposit' || type === 'income') {
      return 'fa-arrow-down';
    } else if (type === 'withdrawal' || type === 'expense') {
      return 'fa-arrow-up';
    }
    return 'fa-exchange-alt';
  };

  const teamLabel = transaction.teamMember;
  const showTeam = teamLabel && teamLabel !== '—';

  return (
    <div className="transaction-detail-modal-overlay" onClick={onClose}>
      <div className="transaction-detail-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            <i className={`fas ${getTypeIcon(transaction.type)}`}></i>
            Transaction Details
          </h2>
          <button className="modal-close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="modal-body">
          <div className="transaction-info-grid">
            <div className="info-item">
              <div className="info-label">Transaction ID</div>
              <div className="info-value transaction-id">
                {transaction.transactionId || transaction._id?.slice(-8) || 'N/A'}
              </div>
            </div>

            <div className="info-item">
              <div className="info-label">Type</div>
              <div className="info-value">
                <span className={`type-badge type-${transaction.type}`}>
                  <i className={`fas ${getTypeIcon(transaction.type)}`}></i>
                  {transaction.type}
                </span>
              </div>
            </div>

            <div className="info-item">
              <div className="info-label">Amount</div>
              <div className={`info-value amount-value ${transaction.type === 'deposit' || transaction.type === 'income' ? 'positive' : 'negative'}`}>
                {transaction.type === 'deposit' || transaction.type === 'income' ? '+' : '-'}
                {formatCurrency(transaction.amount || 0)}
              </div>
            </div>

            <div className="info-item">
              <div className="info-label">Status</div>
              <div className="info-value">
                <span 
                  className="status-badge" 
                  style={{ backgroundColor: getStatusColor(transaction.status) }}
                >
                  <i className={`fas fa-${transaction.status === 'completed' ? 'check-circle' : transaction.status === 'pending' ? 'clock' : 'exclamation-circle'}`}></i>
                  {transaction.status}
                </span>
              </div>
            </div>

            <div className="info-item">
              <div className="info-label">Source</div>
              <div className="info-value">{transaction.source || 'N/A'}</div>
            </div>

            {transaction.accountName && (
              <div className="info-item">
                <div className="info-label">Account Name</div>
                <div className="info-value">{transaction.accountName}</div>
              </div>
            )}

            {transaction.orderNumber && (
              <div className="info-item">
                <div className="info-label">Order Number</div>
                <div className="info-value order-ref">{transaction.orderNumber}</div>
              </div>
            )}

            {showTeam && (
              <div className="info-item">
                <div className="info-label">Team member</div>
                <div className="info-value">{teamLabel}</div>
              </div>
            )}

            <div className="info-item">
              <div className="info-label">Date</div>
              <div className="info-value">{formatDate(transaction.transactionDate || transaction.createdAt)}</div>
            </div>

            {transaction.description && (
              <div className="info-item full-width">
                <div className="info-label">Description</div>
                <div className="info-value description-text">{transaction.description}</div>
              </div>
            )}

            {transaction.isCOD && (
              <div className="info-item full-width">
                <div className="info-label">Note</div>
                <div className="info-value cod-note">
                  <i className="fas fa-money-bill-wave"></i>
                  This is a Cash on Delivery transaction from an order
                </div>
              </div>
            )}

            {transaction.isOrderSourced && !transaction.isCOD && (
              <div className="info-item full-width">
                <div className="info-label">Note</div>
                <div className="info-value cod-note">
                  <i className="fas fa-shopping-bag"></i>
                  Recorded from a confirmed store order (Team Sales rules)
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-close" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetailModal;
